export default __webpack_public_path__ + "static/media/022-pedestrian crossing.10e3b5d0.png";